"use client";
import React from "react";
import Header from "../component/Header.jsx";
import Footer from "../component/Footer.jsx";
import { useForm } from "react-hook-form";
import { useDemo } from "../context/DemoContext.jsx";

import { yupResolver } from "@hookform/resolvers/yup";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { contactSchema, demoSchema } from "../actions/formActions";

const ContactUs = () => {
  const { demoValue } = useDemo();
  // console.log("demoValuedemoValue", demoValue);
  // const [notes, setNotes] = useState(300);
  const schema = demoValue === "true" ? demoSchema : contactSchema;

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const message = watch("message", ""); // 'message' is the field name
  const phonewithSpace = watch("phone", ""); // 'message' is the field name
  const phoneNumber = phonewithSpace?.replace(/\s+/g, '');
  // console.log("asdfasdfadsfadsf,", message);

  const onSubmit = (data) => {
    if (demoValue === "true") {
      // Show demo-related fields only
      const { fullname, email, companyName, demoDate, message } = data;
      console.log("🚀 Demo Data:", {
        fullname,
        email,
        companyName,
        demoDate,
        message,
      });
    } else {
      // Show contact-related fields only
      const { fullname, email, phone, subject, message } = data;
      console.log("📩 Contact Data:", {
        fullname,
        email,
        phone,
        subject,
        message,
      });
    }

    reset(); // ✅ Clear form after submit
  };

  return (
    <>
      <Header
      // setShowDemo={setShowDemo}
      />
      {/* <ContactUsSection /> */}

      {/* <!-- Page Banner Start --> */}

      {/* <!-- Page Banner End --> */}

      {/* <!-- Contact Info Start --> */}

      {/* <!-- Contact Info End --> */}
      {demoValue !== null && demoValue === "true" && (
        <div
          className="section techwix-contact-section-1"
          style={{ backgroundImage: "url(/images/bg/choose-us-bg3.jpg)" }}
        >
          <div className="container">
            <div className="contact-wrap-section1">
              <div className="row">
                <div className="col-lg-6">
                  {/* <!-- Skill Left Start --> */}
                  <div className="contact-left">
                    <div className="section-title">
                      <h3>See Our Blockchain Solutions in Action</h3>
                    </div>
                    <p className="contact-section-text">
                      Curious how our technology can power your next crypto
                      exchange, NFT marketplace, Web3 app, or custom blockchain
                      platform? Book a live demo with our team and explore how
                      we turn ideas into production-ready solutions.
                    </p>
                  </div>
                  {/* <!-- Skill Left End --> */}
                </div>
                <div className="col-lg-6">
                  {/* <!-- Skill Right Start --> */}
                  <div className="contact-right">
                    {/* <!-- Skill Item Start --> */}
                    <div className="contact-item">
                      <h3>🚀 What to Expect in the Demo:</h3>
                      <ol className="techwix-demo-itemList">
                        <li>
                          A walkthrough of our recent projects (CEX, DEX, NFT,
                          bots, etc.)
                        </li>
                        <li>Live product demo tailored to your interest</li>
                        <li>Technical capabilities and integration options</li>
                        <li>Q&A session with our blockchain experts</li>
                        <li>
                          Discussion on how we can help launch or scale your
                          project
                        </li>
                      </ol>
                    </div>
                    {/* <!-- Skill Right End --> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <!-- Contact Start --> */}
      <div className="section techwix-contact-section techwix-contact-section-02 techwix-contact-section-03 section-padding-02">
        <div className="container">
          {/* <!-- Contact Wrap Start --> */}
          <div className="contact-wrap">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                {/* <!-- Contact Form Start --> */}
                <div className="contact-form">
                  <div className="contact-form-wrap">
                    <div className="heading-wrap text-center">
                      {/* <span className="sub-title"> request a quote</span> */}
                      {/* <h3 className="title">How May We Help You!</h3> */}
                      <h3 className="text">
                        {demoValue !== null && demoValue !== "true"
                          ? "Let’s Build Something Great Together"
                          : "📝 Request a Demo Today"}
                      </h3>
                      <p>
                        {demoValue !== null && demoValue !== "true"
                          ? ` We’re always excited to hear from startups, enterprises,
                        and visionaries exploring blockchain technology. Whether
                        you're planning your next big idea or need experts to
                        scale your existing project, we're here to help.`
                          : "Please fill out the form below, and our team will get back to you within 24 hours to schedule your session."}
                      </p>
                    </div>

                    <Form action="#" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="single-form">
                            <input
                              autoComplete="off"
                              type="phone"
                              placeholder="Full Name *"
                              {...register("fullname")}
                            />
                            {errors.fullname && (
                              <p style={{ color: "red" }}>
                                {errors.fullname.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-sm-6">
                          <div className="single-form">
                            <input
                            autoComplete="off"

                              type="email"
                              placeholder="Email *"
                              {...register("email")}
                            />
                            {errors.email && (
                              <p style={{ color: "red" }}>
                                {errors.email.message}
                              </p>
                            )}
                          </div>
                        </div>

                        {demoValue !== null && demoValue !== "true" ? (
                          <div className="col-sm-6">
                            <div className="single-form">
                              <PhoneInput
                              autoComplete="off"
                              value={phoneNumber}
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="AE"
                                limitMaxLength
                                focusInputOnCountrySelection
                                {...register("phone")}
                                onChange={(phone) =>
                                {return phone}
                                }
                              />
                              {errors.phone && (
                                <p style={{ color: "red" }}>
                                  {errors.phone.message}
                                </p>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="col-sm-6">
                            <div className="single-form">
                              <input
                              autoComplete="off"
                                type="text"
                                placeholder="Company / Project Name*"
                                {...register("companyName")}
                              />
                              {errors.companyName && (
                                <p style={{ color: "red" }}>
                                  {errors.companyName.message}
                                </p>
                              )}
                            </div>
                          </div>
                        )}

                        {demoValue !== null && demoValue !== "true" ? (
                          <div className="col-sm-12">
                            <div className="single-form">
                              <input
                              autoComplete="off"

                                maxLength={30}
                                type="text"
                                placeholder="Subject *"
                                {...register("subject")}
                              />
                              {errors.subject && (
                                <p style={{ color: "red" }}>
                                  {errors.subject.message}
                                </p>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="col-sm-12">
                            <div className="single-form">
                              <input
                              autoComplete="off"
                                type="date"
                                placeholder="Preferred Demo Date & Time"
                                {...register("demoDate")}
                              />
                              {errors.demoDate && (
                                <p style={{ color: "red" }}>
                                  {errors.demoDate.message}
                                </p>
                              )}
                            </div>
                          </div>
                        )}

                        <div className="col-sm-12">
                          <div className="single-form">
                            <textarea
                              autoComplete="off"
                              maxLength={300}
                              placeholder="Write A Message"
                              {...register("message")}
                            ></textarea>
                            <div className="d-flex justify-content-end">
                              <span>
                                {" "}
                                <span
                                  className={
                                    300 - message.length <= 20
                                      ? "text-danger"
                                      : ""
                                  }
                                >
                                  {300 - message.length}
                                </span>
                                /300
                              </span>
                            </div>
                            {errors.message && (
                              <p style={{ color: "red" }}>
                                {errors.message.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-sm-12">
                          <div className="form-btn">
                            <button className="btn" type="submit">
                              Send Message
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>

                {/* <!-- Contact Form End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Contact Wrap End --> */}
        </div>
      </div>
      {/* <!-- Contact End --> */}

      <div className="section contact-info-section section-padding-02">
        <div className="container">
          {/* <!-- Contact Info Wrap Start --> */}
          <div className="contact-info-wrap">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                {/* <!--Single Contact Info Start --> */}
                <div className="single-contact-info text-center">
                  <div className="info-icon">
                    <img src="/images/info-1.png" alt="" />
                  </div>
                  <div className="info-content">
                    <h5 className="title">Give us a call</h5>
                    <p>(+1) 400-630 123</p>
                    <p>(+2) 500-950 456</p>
                  </div>
                </div>
                {/* <!--Single Contact Info End --> */}
              </div>
              <div className="col-lg-4 col-sm-6">
                {/* <!--Single Contact Info Start --> */}
                <div className="single-contact-info text-center">
                  <div className="info-icon">
                    <img src="/images/info-2.png" alt="" />
                  </div>
                  <div className="info-content">
                    <h5 className="title">Drop us a line</h5>
                    <p>info@acliss-global.com</p>
                    <p>mail@acliss-global.com</p>
                  </div>
                </div>
                {/* <!--Single Contact Info End --> */}
              </div>
              <div className="col-lg-4 col-sm-6">
                {/* <!--Single Contact Info Start --> */}
                <div className="single-contact-info text-center">
                  <div className="info-icon">
                    <img src="/images/info-3.png" alt="" />
                  </div>
                  <div className="info-content">
                    <h5 className="title">Visit our office</h5>
                    <p>New York. 112 W 34th St caroline, USA</p>
                  </div>
                </div>
                {/* <!--Single Contact Info End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Contact Info Wrap End --> */}
        </div>
      </div>

      {/* <!-- Contact Map Start --> */}
      <div className="section contact-map-section">
        <div className="contact-map-wrap">
          <iframe
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?q=New%20York%20University%20&t=m&z=10&output=embed&iwloc=near"
            title="New York University"
            aria-label="New York University"
            frameBorder="0"
          ></iframe>
        </div>
      </div>
      {/* <!-- Contact Map End --> */}
      <Footer />
    </>
  );
};
export default ContactUs;
